export default "__VITE_ASSET__b9366efb__"